import axios from "axios";
import qs from "qs";

// 测试地址  http://192.168.16.79:3230 
// 正式 http://postsale.haoshuaji.com:8080
let baseURL = "";
if (process.env.NODE_ENV === "development") {
  // baseURL = "http://192.168.16.79:3230"; 
  baseURL = "http://postsale.haoshuaji.com";

} else if (process.env.NODE_ENV === "test") {
  baseURL = "http://postsale.haoshuaji.com";
} else {
  baseURL = "http://postsale.haoshuaji.com";
}
let baseURL2 = "http://clientapi.haoshuaji.com";
export default {
  postForm(url, data) {
    return axios({
      method: "post",
      url: `${baseURL2}${url}`,
      // data: qs.stringify(data),
      data: data,
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 10000
    });
  },
  post(url, data) {
    return axios({
      method: "post",
      url: `${baseURL}${url}`,
      // data: qs.stringify(data),
      data: data,
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 10000
    });
  },
  put(url, data) {
    return axios({
      method: "put",
      url: `${baseURL}${url}`,
      data: qs.stringify(data),
      timeout: 10000
    });
  },
  delete(url, data) {
    return axios({
      method: "delete",
      url: `${baseURL}${url}`,
      data: qs.stringify(data),
      timeout: 10000,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },
  get(url, params) {
    return axios({
      method: "get",
      url: `${baseURL}${url}`,
      params: params,
      timeout: 10000
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js